import { Box, Heading, Image, Link, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { Link as RouterLink } from "react-router-dom";
import { useBrand } from "brand/BrandConfig";
import { UnauthLayout } from "layouts/UnauthLayout";
import { useAuthStore } from "stores/AuthStoreProvider";
import { PRICING_URL } from "src/brand.config";

/** RouteGuard parks signed-in users without an active membership here. */
export const SubscribePage = observer(() => {
  const brand = useBrand();
  const authStore = useAuthStore();

  return (
    <UnauthLayout>
      <Image src={brand.logo} alt={brand.name} width="120px" mx="auto" mb={6} />
      <Box textAlign="center" color="white">
        <Heading size="lg" mb={2}>
          No active membership
        </Heading>
        <Text color="whiteAlpha.700" mb={6}>
          {authStore.user?.data.email
            ? `${authStore.user.data.email} has no active ${brand.name} membership.`
            : `This account has no active ${brand.name} membership.`}
        </Text>
        <Link
          href={PRICING_URL}
          display="block"
          bg="white"
          color="black"
          fontWeight="semibold"
          borderRadius="md"
          py={3}
          mb={3}
          _hover={{ textDecoration: "none", bg: "gray.100" }}
        >
          See plans
        </Link>
        <Text fontSize="sm" color="whiteAlpha.600">
          Paid already? Email {brand.email}.{" "}
          <RouterLink to="/logout">
            <Text as="span" textDecoration="underline">
              Sign out
            </Text>
          </RouterLink>
        </Text>
      </Box>
    </UnauthLayout>
  );
});
